import React from 'react';
import { Upload, Modal } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import style from './PicturesWall.module.css'

function getBase64( file ) {
	return new Promise(( resolve, reject ) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = error => reject(error);
	});
}

export class PicturesWall extends React.Component {
	state = {
		previewVisible: false,
		previewImage: '',
		previewTitle: '',
	};


	handlePreview = async file => {
		if ( !file.url && !file.preview ) {
			file.preview = await getBase64(file.originFileObj);
		}

		this.setState({
			previewImage: file.url || file.preview,
			previewVisible: true,
			previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
		});
	};

	handleChange = ({fileList} ) => {
		const {onFileChange}=this.props;
		onFileChange(fileList)
	}
	render() {
		const { previewVisible, previewImage, previewTitle } = this.state;
		const {fileList}=this.props;
		const uploadButton = (
				<div>
					<PlusOutlined/>
					<div>Upload</div>
				</div>
		);
		return (
				<div className={style.pictures_walls_container}>
					<Upload
							accept="image/*"
							beforeUpload={() => false}
							listType="picture-card"
							fileList={ fileList }
							name='fileList'
							onPreview={ this.handlePreview }
							onChange={ this.handleChange }
					>
						{ fileList.length < 6 ? uploadButton : null }
					</Upload>
					<Modal
							visible={ previewVisible }
							title={ previewTitle }
							footer={ null }
							onCancel={ () => this.setState({ previewVisible: false }) }
					>
						<img alt="example" style={ { width: '100%' } } src={ previewImage }/>
					</Modal>
				</div>
		);
	}
}
